import {Injectable} from '@angular/core';
import {Moment} from 'moment';
import {NyTzMoment} from '../shared/ny-tz-moment.service';


@Injectable()

export class DaysCountService {


	constructor(private nyTzMoment: NyTzMoment) {

	}


	public countDaysInRange(from: number, to: number): number {
		const f: Moment = this.nyTzMoment.create(from);
		const t: Moment = this.nyTzMoment.create(to);

		f.startOf('day');
		t.startOf('day');

		return t.diff(f, 'days') + 1;
	}

	public countWeekendsInRange(from: number, to: number): number {
		const f: Moment = this.nyTzMoment.create(from);
		const t: Moment = this.nyTzMoment.create(to);
		let count: number = 0;

		while (f.isSameOrBefore(t)) {
			if (f.isoWeekday() === 6 || f.isoWeekday() === 7) {
				count += 1;
			}
			f.add(1, 'day');
		}

		return count;
	}
}



// WEBPACK FOOTER //
// ./src/app/reports/days-count.service.ts